export default __webpack_public_path__ + "images/icons/close-bold-734bcc4cfbee875fd9137ebf8d9f6b1b.svg";